module.exports = __webpack_public_path__ + "img/sons.5d8cbc61.gif";